<template>
    <div class="saved container-fluid">
        <h1 class="top">Browse Hot Springs</h1>
        
        <Paginaton :data="sites" 
                   v-on:pagination-change-page="changePage"
                   :show-disabled="true"
                   :limit="5"
                   size="small"
                   align="center"
                   class="mt-5 mb-5"
        >
            <span slot="prev-nav"><fa-icon :icon="['fal', 'angle-double-left']" /></span>
            <span slot="next-nav"><fa-icon :icon="['fal', 'angle-double-right']" /></span>
        </Paginaton>
        
        <div class="same-height-tiles">
            <SiteTile v-for="site in sites.data" class="tile" :key="site.id" :tile-data="site" @data-changed="dataChanged" />
        </div>
        
        <Paginaton :data="sites" 
                   v-on:pagination-change-page="changePage"
                   :show-disabled="true"
                   :limit="5"
                   size="small"
                   align="center"
                   class="mt-5 mb-5"
        >
            <span slot="prev-nav"><fa-icon :icon="['fal', 'angle-double-left']" /></span>
            <span slot="next-nav"><fa-icon :icon="['fal', 'angle-double-right']" /></span>
        </Paginaton>
    </div>
</template>

<script>
import axios from 'axios'
import SiteTile from '@/components/tiles/SiteTile.vue'
import Paginaton from 'laravel-vue-pagination'
import VueScrollTo from 'vue-scrollto'

export default {
    name: 'Saved',
    head: {
        title() {
            return {
                inner: 'Browse Hot Springs',
            }
        },
    },
    components: {
        SiteTile,
        Paginaton,
    },
    data() {
        return {
            sites: {},
            page: this.page || 1,
        }
    },
    url: {
        page: 'page',
    },
    methods: {
        changePage(page = 1) {
            this.page = page
            this.loadSites()
        },
        loadSites() {
            let loader = this.$loading.show();
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/sites?limit=48&page=' + this.page,
                method: 'GET',
            }).then(response => {
                loader.hide()
                this.sites = response.data;
                VueScrollTo.scrollTo('.top', 500)
            }).catch(error => {
                loader.hide()
                console.log({ error: error })
            })
        },
        dataChanged(siteData) {
            let foundIndex = this.sites.data.findIndex(fSite => fSite.id == siteData.id)
            this.sites.data.splice(foundIndex, 1, siteData)
        },
    },
    created() {
        this.loadSites();
    },
    activated() {
        this.$emit('updateHead')
    },
};
</script>

<style lang="scss">

</style>